(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["s6-premium-cursor"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__s6PremiumCursor) return;
    window.__s6PremiumCursor = true;

    const eligible =
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!eligible) return;

    const canvas = document.getElementById('s6-cursor');
    if (!canvas || !canvas.getContext) return;

    try {
      const ctx = canvas.getContext('2d');
      const html = document.documentElement;

      const INTERACTIVE =
        'a, button, [role="button"], input:not([type="text"]):not([type="email"]):not([type="tel"]):not([type="search"]):not([type="number"]):not([type="password"]), select, summary, label[for], [tabindex]:not([tabindex="-1"])';
      const TEXT_FIELD =
        'input[type="text"], input[type="email"], input[type="tel"], input[type="search"], input[type="number"], input[type="password"], input:not([type]), textarea, [contenteditable=""], [contenteditable="true"]';
      const CART =
        '.cart-drawer, .cart-page, cart-drawer, cart-items-component, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog';

      const COUNT = 13;
      let dpr = Math.min(window.devicePixelRatio || 1, 2);

      const resize = () => {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(window.innerWidth * dpr);
        canvas.height = Math.round(window.innerHeight * dpr);
        canvas.style.width = `${window.innerWidth}px`;
        canvas.style.height = `${window.innerHeight}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      };
      resize();
      window.addEventListener('resize', resize);

      let mouseX = window.innerWidth / 2;
      let mouseY = window.innerHeight / 2;
      let started = false;
      const points = Array.from({ length: COUNT }, () => ({ x: mouseX, y: mouseY }));

      window.addEventListener(
        'pointermove',
        (event) => {
          mouseX = event.clientX;
          mouseY = event.clientY;
          if (!started) {
            started = true;
            points.forEach((p) => {
              p.x = mouseX;
              p.y = mouseY;
            });
          }
        },
        { passive: true }
      );

      let interactive = false;
      document.addEventListener(
        'pointerover',
        (event) => {
          html.classList.toggle('s6-cursor-cart', !!event.target.closest(CART));
          if (event.target.closest(TEXT_FIELD)) {
            html.classList.add('s6-cursor-text');
            interactive = false;
          } else if (event.target.closest(INTERACTIVE)) {
            html.classList.remove('s6-cursor-text');
            interactive = true;
          } else {
            html.classList.remove('s6-cursor-text');
            interactive = false;
          }
        },
        { passive: true }
      );

      let pulse = 0;
      window.addEventListener('pointerdown', () => (pulse = 1), { passive: true });

      const draw = (time) => {
        const headEase = 0.5;
        points[0].x += (mouseX - points[0].x) * headEase;
        points[0].y += (mouseY - points[0].y) * headEase;
        const linkEase = interactive ? 0.42 : 0.26;
        for (let i = 1; i < points.length; i++) {
          points[i].x += (points[i - 1].x - points[i].x) * linkEase;
          points[i].y += (points[i - 1].y - points[i].y) * linkEase;
        }
        pulse *= 0.9;

        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

        const waveAmp = interactive ? 1.4 : 3;
        const t = time / 1000;

        for (let i = points.length - 1; i >= 1; i--) {
          const p = points[i];
          const prev = points[i - 1];
          const dx = p.x - prev.x;
          const dy = p.y - prev.y;
          const len = Math.hypot(dx, dy) || 1;
          const perpX = -dy / len;
          const perpY = dx / len;
          const wobble = Math.sin(t * 2.1 + i * 0.85) * waveAmp * (i / points.length);
          const x = p.x + perpX * wobble;
          const y = p.y + perpY * wobble;

          const tailRatio = i / (points.length - 1);
          const radius = Math.max(1.1, 5.2 * (1 - tailRatio) + 1.1);
          const alpha = Math.max(0.05, 0.8 * (1 - tailRatio * 0.85));

          const gradient = ctx.createRadialGradient(x, y, 0, x, y, radius * 1.8);
          gradient.addColorStop(0, `rgba(244, 206, 128, ${alpha})`);
          gradient.addColorStop(0.6, `rgba(190, 134, 42, ${alpha * 0.85})`);
          gradient.addColorStop(1, 'rgba(190, 134, 42, 0)');

          ctx.shadowColor = 'rgba(198, 146, 56, 0.45)';
          ctx.shadowBlur = 5;
          ctx.fillStyle = gradient;
          ctx.beginPath();
          ctx.arc(x, y, radius, 0, Math.PI * 2);
          ctx.fill();

          ctx.shadowBlur = 0;
          ctx.lineWidth = 0.7;
          ctx.strokeStyle = `rgba(56, 38, 12, ${alpha * 0.4})`;
          ctx.stroke();
        }

        const head = points[0];
        const headRadius = (interactive ? 7 : 6) * (1 + pulse * 0.35);
        const headGradient = ctx.createRadialGradient(head.x, head.y, 0, head.x, head.y, headRadius * 2);
        headGradient.addColorStop(0, `rgba(255, 226, 160, ${interactive ? 1 : 0.95})`);
        headGradient.addColorStop(0.55, 'rgba(214, 160, 62, 0.9)');
        headGradient.addColorStop(1, 'rgba(214, 160, 62, 0)');
        ctx.shadowColor = 'rgba(214, 160, 62, 0.55)';
        ctx.shadowBlur = interactive ? 11 : 7;
        ctx.fillStyle = headGradient;
        ctx.beginPath();
        ctx.arc(head.x, head.y, headRadius, 0, Math.PI * 2);
        ctx.fill();
        ctx.shadowBlur = 0;
        ctx.lineWidth = 0.8;
        ctx.strokeStyle = 'rgba(56, 38, 12, 0.4)';
        ctx.stroke();

        ctx.beginPath();
        ctx.fillStyle = '#241a08';
        ctx.arc(mouseX, mouseY, 1.6, 0, Math.PI * 2);
        ctx.fill();
        ctx.lineWidth = 0.6;
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.85)';
        ctx.stroke();
      };

      let raf = 0;
      const tick = (time) => {
        draw(time);
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) cancelAnimationFrame(raf);
        else raf = requestAnimationFrame(tick);
      });

      canvas.hidden = false;
      html.classList.add('s6-cursor-active');
    } catch (error) {
      document.documentElement.classList.remove('s6-cursor-active', 's6-cursor-text', 's6-cursor-cart');
      canvas.hidden = true;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
